import { MsalProvider } from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { routeTree } from "./routeTree.gen";
import { msalInstance } from "./services/auth/msalConfig";
import "./index.css";

const queryClient = new QueryClient();

// Create a new router instance. The `queryClient` is part of the router
// context so route guards (`beforeLoad`) can call `queryClient.ensureQueryData`
// to fetch the admin user-context for permission checks.
const router = createRouter({
	routeTree,
	context: {
		queryClient,
	},
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

// Initialize MSAL and then render
msalInstance.initialize().then(() => {
	// Handle redirect response if needed
	msalInstance
		.handleRedirectPromise()
		.then((authResult) => {
			// Check if user is signed in
			const account = msalInstance.getActiveAccount();
			if (!account && msalInstance.getAllAccounts().length > 0) {
				msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
			}
			if (authResult?.account) {
				msalInstance.setActiveAccount(authResult.account);
			}

			const rootElement = document.getElementById("root")!;
			if (!rootElement.innerHTML) {
				const root = ReactDOM.createRoot(rootElement);
				root.render(
					<React.StrictMode>
						<QueryClientProvider client={queryClient}>
							<MsalProvider instance={msalInstance}>
								<RouterProvider router={router} />
							</MsalProvider>
						</QueryClientProvider>
					</React.StrictMode>,
				);
			}
		})
		.catch((e) => {
			console.error(e);
		});
});
